import { Device } from '@capacitor/device'

const isIpadDevice = async () => {
  const info = await Device.getInfo()
  const infoString = JSON.stringify(info).toLowerCase()
  return infoString.includes('ipad')
}

export default isIpadDevice
